module.exports = __webpack_public_path__ + "static/CM-logo-2e2e4a752748790fcead4e36175d2d76.webp";